/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

interface MessagesProps {
  [key: string]: {
    id: string;
    defaultMessage: string;
  };
}

export const messages: MessagesProps = defineMessages({
  'account.resetPassword.success': {
    id: 'account.resetPassword.success',
    defaultMessage: 'Successfully reset password',
  },
  termsUrl: {
    id: 'login.terms.url',
    defaultMessage: 'nl/pages/voorwaarden',
  },
  notFound: {
    id: 'account.login.error.notFound',
    defaultMessage: 'No customer found with the given email and password',
  },
  invalidEmail: {
    id: 'account.login.error.email.notFound',
    defaultMessage: 'No customer found with the given email',
  },
  invalidPassword: {
    id: 'account.login.error.invalidPassword',
    defaultMessage: 'Your password is wrong, please try again with another password or try resetting password',
  },
  defaultError: {
    id: 'account.login.error',
    defaultMessage: 'Login failed',
  },
  loginMigrated: {
    id: 'account.login.error.loginMigrated',
    defaultMessage: 'Reset your password to secure your account.',
  },
  invalidEmailFriendly: {
    id: 'account.login.error.email.notFound.friendly',
    defaultMessage: 'Unfortunately, we could not find your account. Did you make a typo? If not, please register a new account.',
  },
  invalidPasswordFriendly: {
    id: 'account.login.error.invalidPassword.friendly',
    defaultMessage: 'Your password is wrong, please try again with another password or try resetting password',
  },
  notFoundFriendly: {
    id: 'account.login.error.notFound.friendly',
    defaultMessage: 'Unfortunately, we could not find your account. Did you make a typo? If not, please register a new account.',
  },
  defaultErrorFriendly: {
    id: 'account.login.error.friendly',
    defaultMessage: 'Unfortunately, we could not log you in. Please try again.',
  },
  loginMigratedFriendly: {
    id: 'account.login.error.loginMigratedFriendly',
    defaultMessage: 'It looks like you\'re having trouble logging in. Please reset your password to ensure your account is secure.',
  },
});
